module.exports = __webpack_public_path__ + "media/images/gallery_5-05aa0ee5.jpg";